import type {Module} from "vuex";
import type {RootState} from "@/store/types";

import items from "./countries/items";

export interface Country {
    name: string
    alpha2: string
    alpha3: string
    numeric: string
}

export interface DbCountriesState {
    items: Country[]
}

const countries: Module<DbCountriesState, RootState> = {
    namespaced: true,
    state: {
        items,
    },
    getters: {
        items: (state): Country[] => state.items.sort((a, b) => a.name.localeCompare(b.name))
    }
}

export default countries
